import { render, staticRenderFns } from "./MultiOther.vue?vue&type=template&id=39d70224"
import script from "./MultiOther.vue?vue&type=script&lang=js"
export * from "./MultiOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports